import React, { Component } from 'react';

function getExperience() {
	try {
		const raw =
			window.localStorage.getItem('experience') ||
			window.localStorage.getItem('Experience') ||
			window.localStorage.getItem('siteExperience') ||
			window.localStorage.getItem('cubsExperience') ||
			window.localStorage.getItem('intranet_selected_group') ||
			'internal';

		const value = String(raw).toLowerCase();
		if (value.indexOf('seasonal') !== -1) return 'seasonal';
		if (value.indexOf('internal') !== -1) return 'internal';
		return 'internal';
	} catch (error) {
		return 'internal';
	}
}

function QuickLinks(links){
	return (<ul className="quick-links"> 
		{links.links.map(function(link,index){
			if(link.fileLink){
				return (<li key = {index}>
					<a href= {link.fileLink.url}> {link.text} </a>
				</li>);
			} else {
				return (<li key = {index}>
					<a href= {link.route}> {link.text} </a>
				</li>);
			}
		})}
	</ul>);
}

class Buttons extends Component{

	render(){
		const buttons = this.props.buttons;
		const experience = getExperience();
		const showWidgetIcons = experience === 'internal';
		const widgetLinkClassName = showWidgetIcons
			? 'col sm-6 md-4 header-widget no-border-right widget-link'
			: 'col sm-6 md-4 header-widget no-border-right widget-link seasonal-widget-link';
		const statsLinkClassName = showWidgetIcons
			? 'col sm-6 md-4 header-widget no-border-right border-right widget-link'
			: 'col sm-6 md-4 header-widget no-border-right border-right widget-link seasonal-widget-link';

		return(
			<div className="row"> 
				<a href={buttons.externalLinks[0].route} className={widgetLinkClassName}>
					{showWidgetIcons ? <span className="widget-icon-tickets"/> : null}
					<span className="widget-tickets widget-text">
						{buttons.externalLinks[0].text}
					</span>
				</a>
				<a href={buttons.externalLinks[1].route} className={statsLinkClassName}>
					{showWidgetIcons ? <span className="widget-icon-stats"/> : null}
					<span className="widget-stats widget text">
						{buttons.externalLinks[1].text}
					</span>
				</a>
				<div className="col sm-12 md-4 header-widget">
					<span className="quick-links-header">Quick Links </span>
					<QuickLinks links = {buttons.quickLinks}/>
				</div>
			</div>
		);

	}
}

export default Buttons;
